import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy-choices")({
  beforeLoad: () => {
    throw redirect({ to: "/choices", replace: true, statusCode: 301 });
  },
});
